<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Marka</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Marka" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Logo</label>
            <v-file-uploader v-model="value" :accept="['png','jpg','jpeg']" valueParameter="Logo"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        errors:Object,
    }
}
</script>